export var LIST_CLASSES_USE_CASE = 'LIST_CLASSES_USE_CASE';
export var LIST_ASSIGNMENT_CLASSES_USE_CASE = 'LIST_ASSIGNMENT_CLASSES_USE_CASE';
export var CREATE_CLASS_USE_CASE = 'CREATE_CLASS_USE_CASE';
export var GET_CLASS_USE_CASE = 'GET_CLASS_USE_CASE';
export var LIST_CLASS_TEACHERS_USE_CASE = 'LIST_CLASS_TEACHERS_USE_CASE';
export var LIST_CLASS_STUDENTS_USE_CASE = 'LIST_CLASS_STUDENTS_USE_CASE';
export var UPDATE_CLASS_USE_CASE = 'UPDATE_CLASS_USE_CASE';
export var ARCHIVE_CLASS_USE_CASE = 'ARCHIVE_CLASS_USE_CASE';
export var ACTIVATE_CLASS_USE_CASE = 'ACTIVATE_CLASS_USE_CASE';
export var DELETE_CLASS_USE_CASE = 'DELETE_CLASS_USE_CASE';
export var REMOVE_CLASS_TEACHER_USE_CASE = 'REMOVE_CLASS_TEACHER_USE_CASE';
export var REMOVE_CLASS_STUDENT_USE_CASE = 'REMOVE_CLASS_STUDENT_USE_CASE';
export var GET_CLASS_INVITATION_USE_CASE = 'GET_CLASS_INVITATION_USE_CASE';
export var JOIN_CLASS_AS_TEACHER_USE_CASE = 'JOIN_CLASS_AS_TEACHER_USE_CASE';
export var JOIN_CLASS_AS_STUDENT_USE_CASE = 'JOIN_CLASS_AS_STUDENT_USE_CASE';
export var LEAVE_CLASS_USE_CASE = 'LEAVE_CLASS_USE_CASE';
export var GET_CLASS_INVITATION_BY_CODE_USE_CASE = 'GET_CLASS_INVITATION_BY_CODE_USE_CASE';